import { render, staticRenderFns } from "./ReferFriend.vue?vue&type=template&id=6aedd28e"
import script from "./ReferFriend.vue?vue&type=script&lang=js"
export * from "./ReferFriend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsDatePicker: require('/app/components/Commons/DatePicker.vue').default})
